/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../model/shared/device_profile_type';
import '../model/shared/device_profile_template_type';
import './status';
import '../model/device_profile';
import '../model/shared/device_profile';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "devicesettings": {
        "nested": {
          "profiles": {
            "nested": {
              "v2": {
                "nested": {
                  "message": {
                    "nested": {
                      "CreateDefaultDeviceProfileV2Request": {
                        "fields": {
                          "name": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "deviceProfileType": {
                            "type": ".squareup.devicesettings.profiles.v2.model.shared.DeviceProfileType",
                            "id": 2,
                            "rule": "optional"
                          },
                          "shared": {
                            "type": "bool",
                            "id": 3,
                            "rule": "optional",
                            "options": {
                              "default": true
                            }
                          },
                          "templateType": {
                            "type": ".squareup.devicesettings.profiles.v2.model.shared.DeviceProfileTemplateType",
                            "id": 4,
                            "rule": "optional"
                          }
                        }
                      },
                      "CreateDefaultDeviceProfileV2Response": {
                        "fields": {
                          "status": {
                            "type": ".squareup.devicesettings.profiles.v2.message.Status",
                            "id": 1,
                            "rule": "optional"
                          },
                          "profile": {
                            "type": ".squareup.devicesettings.profiles.v2.model.DeviceProfileV2",
                            "id": 2,
                            "rule": "optional"
                          },
                          "deviceProfile": {
                            "type": ".squareup.devicesettings.profiles.v2.model.shared.DeviceProfile",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.message?.nested?.CreateDefaultDeviceProfileV2Request && !$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.message?.nested?.CreateDefaultDeviceProfileV2Response) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE CreateDefaultDeviceProfileV2Request @ squareup/devicesettings/profiles/v2/message/create_default_device_profile.proto at 15:1
 */
export const CreateDefaultDeviceProfileV2Request = $root.lookupType('squareup.devicesettings.profiles.v2.message.CreateDefaultDeviceProfileV2Request');
fixType(CreateDefaultDeviceProfileV2Request, {
  name: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(CreateDefaultDeviceProfileV2Request);
/**
 * SOURCE CreateDefaultDeviceProfileV2Response @ squareup/devicesettings/profiles/v2/message/create_default_device_profile.proto at 22:1
 */
export const CreateDefaultDeviceProfileV2Response = $root.lookupType('squareup.devicesettings.profiles.v2.message.CreateDefaultDeviceProfileV2Response');
fixType(CreateDefaultDeviceProfileV2Response);
Builder.createAndAttachToType(CreateDefaultDeviceProfileV2Response);